module.exports = __webpack_public_path__ + "static/media/why_th.58010952.vtt";